export const MEDUSA_API_URL = process.env.REACT_APP_MEDUSA_API_URL || 'http://localhost:9000';
export const MEDUSA_API_KEY = process.env.REACT_APP_MEDUSA_PUBLISHABLE_KEY;

// Llave publicable de Stripe (pk_test_… o pk_live_…). El checkout monta el
// Payment Element con esta llave; el cobro real lo procesa el backend.
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Region de Medusa a usar en el checkout (opcional). Si hay una sola region
// (México/MXN) Medusa la asigna por defecto y puedes dejar esto vacío. Con
// varias regiones, fija la de MXN que tiene Stripe habilitado.
export const MEDUSA_REGION_ID = process.env.REACT_APP_MEDUSA_REGION_ID || null;

// Identificador del provider de pago Stripe registrado en el backend.
// Se arma como pp_{identifier}_{id}; con la config actual es pp_stripe_stripe.
export const STRIPE_PROVIDER_ID = 'pp_stripe_stripe';
